import { render, staticRenderFns } from "./FormFpostgrad.vue?vue&type=template&id=28609646&"
import script from "./FormFpostgrad.vue?vue&type=script&lang=js&"
export * from "./FormFpostgrad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports